import React from 'react';
import { DropDown } from './common';
import { connect } from 'react-redux';
import {validatable} from 'components/utils';
import { DuLieuHeThong } from 'api';

class DropDownChonTinhThanh extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      value: this.props.selectedValue,
      data: this.props.data
    }
  }

  componentDidMount() {
    if(this.props.data.length == 0) {
      DuLieuHeThong.actions.getCapTinhThanhPho.request().then(res => {
        this.props.dispatch({
          type: 'CAPNHAT_DULIEUHETHONG',
          duLieuHeThong: [{
            key: 'capTinhThanhPho',
            data: res.data && res.data._embedded && res.data._embedded.donViHanhChinhs ? res.data._embedded.donViHanhChinhs : []
          }]
        })
      })
    }
  }

  onChange(e) {
    this.props.onChange(e);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedValue && this.props.selectedValue != nextProps.selectedValue) {
      this.setState({
        value: nextProps.selectedValue
      });
    }
    if (nextProps.data != this.props.data) {
      this.state.data = nextProps.data;
      this.setState({...this.state})
    }
  }

  render() {
    return (
      <DropDown disabled={this.props.disabled} className={this.props.className} selectedValue={this.props.selectedValue} label="Tỉnh" options={ this.state.data } keyName='donViHanhChinhId' valueName='ten' onChange={ this.onChange.bind(this) } placeholder={ this.props.placeholder } require={this.props.require} bindValidator={this} channel="danhMuc" name="tinhThanh"/>
    )
  }
}

DropDownChonTinhThanh.defaultProps = {
  className: 'col-input',
  onChange: function() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  selectedValue: '',
  isValid: false,
  require: false,
  data: [],
  disabled: false
}

let bindStateToProps = state => {
  return {
    data: state.duLieuHeThong.capTinhThanhPho
  }
}

export default connect(bindStateToProps)(validatable(DropDownChonTinhThanh));



// WEBPACK FOOTER //
// ./src/components/tt-forms/dropdown-tinhthanh.jsx